import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from '../lib/api';
import { useAuth } from './AuthContext';
import { useWorkspace } from './WorkspaceContext';

/**
 * Coverage info for each report (TE301, TE395, AR317, TE326, IC338).
 * Cached at app level — refreshed on workspace change or manual refresh.
 *
 * Shape:
 * { TE301: {kind, min_date, max_date, total_rows, mode, source_label_es, last_upload: {...}}, ... }
 */
const DataCoverageContext = createContext({ coverage: null, loading: false, error: null, refresh: () => {} });

export function DataCoverageProvider({ children }) {
  const { user } = useAuth();
  const workspace = useWorkspace();
  const [coverage, setCoverage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    setError(null);
    try {
      const { data } = await api.get('/data/coverage');
      setCoverage(data);
    } catch (e) {
      setError(e?.response?.data?.detail || 'No se pudo cargar metadata');
    } finally {
      setLoading(false);
    }
  }, [user]);

  // Reload when user logs in or workspace switches
  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id, workspace?.active?.id]);

  return (
    <DataCoverageContext.Provider value={{ coverage, loading, error, refresh }}>
      {children}
    </DataCoverageContext.Provider>
  );
}

export const useDataCoverage = () => useContext(DataCoverageContext);
